/**
 * CetusEd Community Portal — Application Layout
 *
 * COMPLIANCE: The layout wraps all authenticated routes with the Header
 *   navigation and an <Outlet /> for child routes. This ensures consistent
 *   branding and navigation across all community portal pages.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';

export const Layout: React.FC = () => {
  return (
    <div className="community-layout">
      <Header />
      <main className="community-main">
        <Outlet />
      </main>
      <footer className="community-footer">
        <p>&copy; {new Date().getFullYear()} CetusEd. All rights reserved.</p>
      </footer>
    </div>
  );
};
